export class FileFunction {
	static getBase64(file: File): Promise<string> {
		return new Promise<string>((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => resolve(reader.result as any);
			reader.onerror = (error) => reject(error);
		});
	}

	static is2MB(file: File): boolean {
		return file.size <= 1024 * 1024 * 2; //2mb
	}

	static isImage(file: File): boolean {
		if (file && file["type"] == "image/svg+xml") return false;
		return file && file["type"].split("/")[0] == "image";
	}

	static isImageOrPdf(file: File): boolean {
		return this.isImage(file) || file["type"] == "application/pdf";
	}

	static isPdf(file: File): boolean {
		return file["type"] == "application/pdf";
	}

	static downloadPdf(fileUrl: string, fileName: string): void {
		const link = document.createElement('a');
		link.href = fileUrl; 
		link.download = fileName + '.pdf';
		link.target = '_blank';
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}	   

	static base64ToBlob(base64: string, contentType: string = '', sliceSize: number = 512): Blob {
		const byteCharacters = atob(base64.split(',')[1]);
		const byteArrays = [];

		for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
				const slice = byteCharacters.slice(offset, offset + sliceSize);

				const byteNumbers = new Array(slice.length);
				for (let i = 0; i < slice.length; i++) {
						byteNumbers[i] = slice.charCodeAt(i);
				}

				const byteArray = new Uint8Array(byteNumbers);
				byteArrays.push(byteArray);
		}

		return new Blob(byteArrays, { type: contentType });
}

}
